import request from '@/utils/request'


export function getCompanyClientsList(param){
  return request({
    url: '/company/getcompanyclientslist',
    method: 'get',
    params:param
  })
}

export function getRolesList() {
  return request({
    url: '/roles/list',
    method: 'get'
  })
}

export function getCompanyPaymentAccountDetail(param){
  return request({
    url: '/company/getcompanypaymentaccountdetail',
    method: 'get',
    params:param
  })
}

export function getCompanyMembersNewClients(data){
  return request({
    url: '/company/getcompanynewclientslist',
    method: 'post',
    data
  })
}


export function getCompanyMembersDailyReport(data){
  return request({
    url: '/company/getcompanymembersdailyreport',
    method: 'post',
    data
  })
}

export function updateCompanySellerWechatDetail(data) {
    return request({
        url: '/company/updatecompanysellerwechatdetail',
        method: 'post',
        data
    })
}

export function getCompanySellerWechatList(data) {
    return request({
        url: '/company/getcompanysellerwechats',
        method: 'get',
        params: data
    })
}

export function getCompanyPreOrderList(data) {
  return request({
    url: '/company/getcompanypreorderlist',
    method: 'post',
    data
  })
}


export function getCompanyReturnVisitList(data) {
    return request({
        url: '/company/getcompanyreturnvisitlist',
        method: 'post',
        data
    })
}
export function getComapnyGroupDailyReport(data) {
    return request({
        url: '/company/getcompanygroupdailyreport',
        method: 'post',
        data
    })
}

export function getCompanySalesData(data) {
  return request({
    url: '/company/getcompanysalesdata',
    method: 'post',
    data
  })
}
export function sellerSettlementV3(param) {
  return request({
    url: '/company/sellersettlementv3',
    method: 'get',
    params:param
  })
}


export function getEmployeeBenefit(param) {
  return request({
    url: '/company/employeebenefit',
    method: 'get',
    params:param
  })
}

export function getCompanyDispatchList(param) {
  return request({
    url: '/company/getcompanydispatchlist',
    method: 'get',
    params:param
  })
}


export function getCompanyClientsCalendar(param) {
  return request({
    url: '/company/getcompanyclientcalendar',
    method: 'get',
    params:param
  })
}


export function changeOrderPrice(param) {
  return request({
    url: '/company/changeorderprice',
    method: 'get',
    params:param
  })
}


export function getUsersList(param) {
  return request({
    url: '/company/getuserslist',
    method: 'get',
    params:param
  })
}

export function getCompanySellerWechatInfo(data) {
  return request({
    url: '/comcompany/getcompanysellerwechatInfo',
    method: 'get',
    params:data
  })
}

export function setCompanyGroupMembers(data) {
  return request({
    url: '/comcompany/setcompanygroupmembers',
    method: 'post',
    data
  })
}


export function getCompanyMembersList() {
  return request({
    url: '/comcompany/getcompanymembers',
    method: 'get'
  })
}

export function getPaymentList(param) {
  return request({
    url: '/comcompany/getpaymentlist',
    method: 'get',
    params: param
  })
}

export function auditPayment(data) {
  return request({
    url: '/comcompany/auditpayment',
    method: 'post',
    data
  })
}

export function auditRefund(data) {
  return request({
    url: '/comcompany/auditrefund',
    method: 'post',
    data
  })
}

export function getRefundList(param) {
  return request({
    url: '/comcompany/getrefundlist',
    method: 'get',
    params: param
  })
}

export function getAllCompanyInfo(data) {
  return request({
    url: '/comcompany/getcompanyinfo',
    method: 'get',
    params: data
  })
}

export function getSellerSettlementlList() {
  return request({
    url: '/comcompany/getsellersettlementlist',
    method: 'get'
  })
}

export function getSellerSettlementlData(id) {
  return request({
    url: '/comcompany/getsellersettlement',
    method: 'get',
    params: { settlementid: id }
  })
}

export function getRefundImage(refundid) {
  return request({
    url: '/comcompany/getrefundimage',
    method: 'get',
    params: {refundid: refundid}
  })
}


export function getCompanyGroups() {
  return request({
    url: '/comcompany/getcompanygroups',
    method: 'get'
  })
}

export function getCompanySellerWechatDetailTable(data) {
  return request({
    url: '/company/getcompanysellerwechatdetailtable',
    method: 'get',
    params: data
  })
}
